/**
 * Sticky dock + help sheet (product page, CRO v1).
 *
 * - The bar is always shown; its CTA shows whenever the buy box CTA is off
 *   screen and steps aside while that one is visible (the help discs stay).
 * - The dock CTA clicks the buy box's own submit button (Dawn product-form:
 *   cart drawer, errors, gifts). It keeps saying "הוספה לסל": the cart
 *   shortcut next to it is the way into the cart.
 * - The cart shortcut shows only while the cart has items (badge = count) and
 *   opens the cart drawer.
 * - The help discs open a bottom sheet (scroll-locked) offering the AI chat
 *   (window.DrAiChat.open) or WhatsApp.
 */
(function () {
  'use strict';

  var LOCK_OWNER = 'dr-help-sheet';

  function init() {
    var dock = document.querySelector('[data-dr-dock]');
    var buyBox = document.querySelector('[data-dr-pack-picker]');
    if (!dock || !buyBox) return;

    var buyCta = buyBox.querySelector('[data-dr-buy-box-cta]');
    var cta = dock.querySelector('[data-dr-dock-cta]');
    var priceEl = dock.querySelector('[data-dr-dock-price]');
    var sheet = document.querySelector('[data-dr-help-sheet]');
    var cartLink = dock.querySelector('[data-dr-dock-cart]');

    /* ---------- Price mirrors the buy box ---------- */
    function syncPrice() {
      var buyPrice = buyBox.querySelector('[data-dr-pack-price]');
      priceEl.innerHTML = buyPrice ? buyPrice.innerHTML : '';
    }
    syncPrice();
    buyBox.addEventListener('dr:buybox:change', syncPrice);

    /* ---------- The bar stays; its CTA shows while the buy box CTA is off screen ---------- */
    function setCtaVisible(visible) {
      dock.classList.toggle('has-cta', visible);
      cta.setAttribute('aria-hidden', visible ? 'false' : 'true');
      cta.tabIndex = visible ? 0 : -1;
    }

    requestAnimationFrame(function () { dock.classList.add('is-visible'); });
    if (buyCta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        setCtaVisible(!entries[0].isIntersecting);
      }).observe(buyCta);
    } else {
      setCtaVisible(true);
    }

    /* ---------- CTA ---------- */
    cta.addEventListener('click', function () {
      if (!buyCta || buyCta.disabled) return;
      cta.classList.add('is-loading');
      buyCta.click();
    });

    /* ---------- Cart shortcut ---------- */
    function setCartCount(count) {
      if (!cartLink) return;
      cartLink.hidden = !(count > 0);
      cartLink.querySelector('[data-dr-dock-cart-count]').textContent = count;
      cartLink.querySelector('[data-dr-dock-cart-label]').textContent = 'סל הקניות, ' + count + ' פריטים';
    }

    function refreshCartCount() {
      fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { setCartCount(cart.item_count); })
        .catch(function () {});
    }

    if (cartLink) {
      cartLink.addEventListener('click', function (event) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          event.preventDefault();
          drawer.open(cartLink);
        }
      });
    }

    // Dawn publishes cartUpdate after adds (product-form) and drawer edits
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'product-form') cta.classList.remove('is-loading');
        refreshCartCount();
      });
      if (PUB_SUB_EVENTS.cartError) {
        subscribe(PUB_SUB_EVENTS.cartError, function () {
          cta.classList.remove('is-loading');
        });
      }
    }

    /* ---------- Help sheet ---------- */
    if (!sheet) return;
    var helpButton = dock.querySelector('[data-dr-dock-help]');
    var panel = sheet.querySelector('[role="dialog"]');

    function openSheet() {
      sheet.hidden = false;
      if (window.DrBodyScrollLock) window.DrBodyScrollLock.lock(LOCK_OWNER);
      if (typeof trapFocus === 'function') trapFocus(panel, sheet.querySelector('[data-dr-help-ai]'));
      else panel.focus();
    }

    function closeSheet(handOver) {
      if (sheet.hidden) return;
      sheet.hidden = true;
      if (window.DrBodyScrollLock) window.DrBodyScrollLock.unlock(LOCK_OWNER);
      // handOver: another dialog (the AI chat) owns focus now
      if (handOver !== true && typeof removeTrapFocus === 'function') removeTrapFocus(helpButton);
    }

    helpButton.addEventListener('click', openSheet);
    sheet.querySelectorAll('[data-dr-help-close]').forEach(function (el) {
      el.addEventListener('click', function () { closeSheet(); });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeSheet();
    });

    sheet.querySelector('[data-dr-help-ai]').addEventListener('click', function () {
      // Open the chat before closing the sheet: the chat takes over the scroll
      // lock while it is still held, so the page keeps its position.
      if (window.DrAiChat && typeof window.DrAiChat.open === 'function') {
        window.DrAiChat.open();
      }
      closeSheet(true);
    });

    var wa = sheet.querySelector('[data-dr-help-wa]');
    if (wa) wa.addEventListener('click', function () { closeSheet(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
